var map = {
	"./credit-card": [
		53181,
		1125,
		3113,
		4756,
		3181
	],
	"./credit-card/": [
		53181,
		1125,
		3113,
		4756,
		3181
	],
	"./credit-card/index": [
		53181,
		1125,
		3113,
		4756,
		3181
	],
	"./credit-card/index.tsx": [
		53181,
		1125,
		3113,
		4756,
		3181
	],
	"./credit-card/installments": [
		87594,
		679
	],
	"./credit-card/installments.tsx": [
		87594,
		679
	],
	"./credit-payment": [
		95209,
		5209
	],
	"./credit-payment.tsx": [
		95209,
		5209
	],
	"./funds-transfer": [
		57422,
		7422
	],
	"./funds-transfer.tsx": [
		57422,
		7422
	],
	"./loyalty": [
		69649,
		9649
	],
	"./loyalty.tsx": [
		69649,
		9649
	],
	"./pay-on-delivery": [
		57132,
		7132
	],
	"./pay-on-delivery.tsx": [
		57132,
		7132
	],
	"./redirection": [
		87389,
		7389
	],
	"./redirection.tsx": [
		87389,
		7389
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 80744;
module.exports = webpackAsyncContext;